import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        licence: '=',
        departments: '=',
        roles: '=',
        levels: '=',
        preconditionCourses: '='
    },
    template: `
    <div class="heading01 type01">
        <h1>{{ vm.licence.name }}</h1>
        <ul class="actions01">
            <li><a class="btn edit" ng-click="vm.edit()">{{ 'licence.Edit general data' | translate }}</a></li>
            <li ng-if="!vm.licence.licencePoints.length">
                <a class="btn delete" ng-click="vm.delete()">{{ 'licence.Delete licence' | translate }}</a>
            </li>
        </ul>
    </div>
    <div class="form">
        <div class="row">
            <label class="label">{{ 'licence.Licence precondition active' | translate }}</label>
            <div class="items">
                <span class="text" ng-if="vm.licence.hasPrecondition">{{ 'general.Yes' | translate }}</span>
                <span class="text" ng-if="!vm.licence.hasPrecondition">{{ 'general.No' | translate }}</span>
            </div>
        </div>
        <div class="row" ng-if="vm.licence.hasPrecondition">
            <label class="label">{{ 'licence.Licence preconditions' | translate }}</label>
            <div class="items">
                <span class="text">{{ vm.preconditionCourseNames.join(', ') }}</span>
            </div>
        </div>
    </div>
    <manage-settings-licences-periods licence="vm.licence"/>
    <manage-settings-licences-targets
        licence="vm.licence"
        departments="vm.departments"
        roles="vm.roles"
        levels="vm.levels"
    />
    <ul class="actions01">
<!--        <li class="primary">-->
<!--            <a ui-sref="authorized.manage.settings.licences.details()" class="btn main">{{ 'licence.Save changes' | translate }}</a>-->
<!--        </li>-->
<!--        <li class="primary">-->
<!--            <a ui-sref="authorized.manage.settings.licences.list()" class="btn negative">{{ 'licence.Delete' | translate }}</a>-->
<!--        </li>-->
        <li><a ui-sref="authorized.manage.settings.licences.list()" class="btn discrete">{{ 'general.Cancel' | translate }}</a></li>
    </ul>
    `
})
export default class {
    constructor ($state, $translate, ModalService, LicenceResource, CourseResource, toastr) {
        this.$state = $state;
        this.$translate = $translate;
        this.ModalService = ModalService;
        this.LicenceResource = LicenceResource;
        this.CourseResource = CourseResource;
        this.toastr = toastr;
    }

    $onInit () {
        this.loadPreconditionCourseNames();
    }

    loadPreconditionCourseNames () {
        this.preconditionCourseNames = this.preconditionCourses.map((course) => course.activeI18n.name);
    }

    edit () {
        const { preconditionCourses, licence } = this;
        return this.ModalService.open({
            size: 'medium',
            template: `
                <modals-manage-licences-edit
                    licence="vm.licence"
                    precondition-courses="vm.preconditionCourses"
                    uib-modal-instance="vm.uibModalInstance"
                />
            `,
            controller ($uibModalInstance) {
                this.uibModalInstance = $uibModalInstance;
                this.licence = licence;
                this.preconditionCourses = preconditionCourses;
            }
        }).then(() => this.reload());
    }

    reload () {
        this.LicenceResource.get({ id: this.licence.id, expand: 'licencePeriods,licenceDrlsWithValue,licencePoints,licencePreconditions' })
            .$promise.then((reloadedLicence) => (this.licence = reloadedLicence));
        this.CourseResource.query({ preconditionCoursesLicenceId: this.licence.id, pageSize: 0, expand: 'activeI18n' })
            .$promise.then((preconditionCourses) => {
                this.preconditionCourses = preconditionCourses;
                this.loadPreconditionCourseNames();
            });
    }

    delete () {
        return this.ModalService.delete(this.$translate.instant('licence.Are you sure you wish to delete the licence?'))
            .then(() => {
                this.LicenceResource.delete({ id: this.licence.id }).$promise
                    .then(response => {
                        this.$state.go('authorized.manage.settings.licences.list', response);
                        this.toastr.success(this.$translate.instant('licence.Licence deleted'));
                    });
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/settings/licences/detail/index.js